export enum FilterStates {
  all = 'ALL',
  published = 'PUBLISHED',
  unpublished = 'UNPUBLISHED',
}
